var exports = {
  "I8": "summaryContainer__6Iz7T9",
  "iW": "updatedSummary__68GJWd",
  "dM": "actorGroup__-i1FTx",
  "ey": "branchGroup__ShMOFt",
  "eN": "actor__HlrwQS",
  "al": "attribution__bQyzNY",
  "A5": "diffStat__P-CCgP",
};

module.exports = exports;
